import { useSearchParams } from 'react-router-dom'

export type ViewMode = 'board' | 'table'

/** Board vs table view for the board screens, in the URL (`?view=table`) so it's
 *  shareable and survives reload. Board is the default (param omitted). */
export function useViewMode(): [ViewMode, (mode: ViewMode) => void] {
  const [params, setParams] = useSearchParams()
  const mode: ViewMode = params.get('view') === 'table' ? 'table' : 'board'

  const setMode = (next: ViewMode) =>
    setParams(
      (p) => {
        const updated = new URLSearchParams(p)
        if (next === 'board') updated.delete('view')
        else updated.set('view', next)
        return updated
      },
      { replace: true },
    )

  return [mode, setMode]
}
